// src/CiqlerDetail.js
import React from "react";
import "./souschef.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function SousChefDetail() {
  return (
    <div>
      <nav className="navbar">
        <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <h1>Ziad Aly</h1>
        </Link>
      </nav>
      <div className="mainbackground">
        <div className="souschef-project-detail notion-style">
          <div className="souschef-video-container">
            <video
              controls
              width="100%"
              src={`${process.env.PUBLIC_URL}/./SousChef.mp4`}
            />
          </div>
          <div className="detail-content">
            <div className="text-container">
              <h1>Souschef</h1>
              <div className="projectImages">
                <img src={`${process.env.PUBLIC_URL}/SousChefLogo.jpeg`} />
              </div>
              <h2>Problem Statement</h2>
              <p>
                Many individuals struggle daily with deciding what to cook,
                existing General AI models often provide inaccurate and
                impersonal recipe suggestions, leading to frustration and
                inefficiency.{" "}
              </p>
              <h2>Value Propestation</h2>
              <p>
                Our App offers an interactive system where users can scan their
                fridge and input food preferences. Our LLM-based platform then
                generates personalized, unlimited validated recipes, simplifying
                and enhancing the meal planning process. Unlike Traditional Apps
                which relies on Static Limited Content.
              </p>
              <h2>Technology</h2>
              <ul>
                <li>MongoDB</li>
                <li>Python Flask</li>
                <li>OpenAI API</li>
                <li>Google Custom Search API</li>
                <li><strong>AWS:</strong> EC2, S3</li>
                <li>Flutter</li>
                <li>Azure DevOps</li>
              </ul>
              <h2>Team</h2>
              <ul>
              <ul>
              <li style={{ marginLeft: "25px" }}>
                  <a
                    href="https://www.linkedin.com/in/ahmed-el-shafei/"
                    style={{ color: "inherit"}}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Ahmed El-Shafei
                  </a>
                </li>
                <li style={{ marginLeft: "25px" }}>
                  <a
                    href="https://www.linkedin.com/in/harshit-agrwal/"
                    style={{ color: "inherit" }}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Harshit Agarwal
                  </a>
                </li>
                <li style={{ marginLeft: "25px" }}>
                  <a
                    href="https://www.linkedin.com/in/yanyu-c-555684297/"
                    style={{ color: "inherit" }}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Yanyu C
                  </a>
                </li>


              </ul>
            </ul>
            <div>
              <h2>Status</h2>
              <p style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    backgroundColor: "#6C757D",
                    borderRadius: "50%",
                    display: "inline-block",
                    marginRight: "8px",
                  }}
                ></span>
                Offline, The backend got deployed for couple of days for showcasing the app on our phones.
              </p>
            </div>              {/* Add more detailed information here if needed */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SousChefDetail;
